import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ApiService } from '../api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { forbiddenEmailValidator } from '../em.validator';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.sass']
})
export class ItemComponent implements OnInit {
  
  @Input() seller: string;

  messageForm: FormGroup
  reportForm: FormGroup

  contact = false
  report = false

  submitted = ""
  imgIndex = 0
  savedMessage = {}
  loading = false
  @ViewChild('contactButton', {read: ElementRef}) contactButton;
  @ViewChild('reportButton', {read: ElementRef}) reportButton;
  @ViewChild('reditem', {read: ElementRef}) redItem;

  @Input() merchandise;
  
  constructor(private apiService: ApiService, private renderer: Renderer2) { }

  ngOnInit() {
    this.messageForm = new FormGroup({
      'from_shopper': new FormControl('', [Validators.required]),
      'title': new FormControl('', [Validators.required]),
      'message': new FormControl('', [Validators.required]),
      'email': new FormControl(null, [Validators.required, forbiddenEmailValidator]),
    });

    this.reportForm = new FormGroup({
      'from_shopper': new FormControl('', [Validators.required]),
      'title': new FormControl('', [Validators.required]),
      'message': new FormControl('', [Validators.required]),
      'email': new FormControl(null, [Validators.required, forbiddenEmailValidator]),
    });
  }

  contactChange(val)  {
    this.contact = val
    this.submitted = ''

    if (val === true) {
      this.report = false
      this.renderer.addClass(this.contactButton.nativeElement,'activated')
      this.renderer.removeClass(this.redItem.nativeElement,'reditem')

      this.renderer.removeClass(this.reportButton.nativeElement,'activatedReport')
    }
      else {
        this.renderer.removeClass(this.contactButton.nativeElement,'activated')
      }
  }

  reportChange(val)  {
    this.report = val
    this.submitted = ''

    if (val === true) {
      this.contact = false
      this.renderer.addClass(this.reportButton.nativeElement,'activatedReport')
      this.renderer.addClass(this.redItem.nativeElement,'reditem')
      this.renderer.removeClass(this.contactButton.nativeElement,'activated')
    }
      else {
        this.renderer.removeClass(this.reportButton.nativeElement,'activatedReport')
        this.renderer.removeClass(this.redItem.nativeElement,'reditem')
      }
  }

  submitMessage(val, val2) {
    val.preventDefault()
    this.submitted = 'loading'

    this.savedMessage['admin'] = ["f6006a3ac4e9", "excessmaterial.official@gmail.com"]
    this.savedMessage['to_seller'] = this.seller
    this.savedMessage['from_shopper'] = this.messageForm.get('from_shopper').value
    this.savedMessage['title'] = this.messageForm.get('title').value
    this.savedMessage['message'] = this.messageForm.get('message').value
    this.savedMessage['email'] = this.messageForm.get('email').value
    this.savedMessage['selleremail'] = val2['email']
    this.savedMessage['report'] = false
    this.savedMessage['post_id'] = val2['id']
    this.savedMessage['tags'] = `${this.seller}, ${this.messageForm.get('from_shopper').value}, ${this.messageForm.get('title').value}, ${this.messageForm.get('message').value}, ${this.messageForm.get('email').value}, ${this.savedMessage['selleremail']}, ${String(this.savedMessage['report'])}, ${String(this.savedMessage['post_id'])}`
    this.apiService.postMessage(this.savedMessage).subscribe(data => {
      this.submitted = 'submitted'
    })
  }

  submitReport(val, val2) {
    val.preventDefault()
    this.submitted = 'loading'

    this.savedMessage['admin'] = ["f6006a3ac4e9", "excessmaterial.official@gmail.com"]
    this.savedMessage['to_seller'] = this.seller
    this.savedMessage['from_shopper'] = this.reportForm.get('from_shopper').value
    this.savedMessage['title'] = this.reportForm.get('title').value
    this.savedMessage['message'] = this.reportForm.get('message').value
    this.savedMessage['email'] = this.reportForm.get('email').value
    this.savedMessage['selleremail'] = val2['email']
    this.savedMessage['report'] = true
    this.savedMessage['post_id'] = val2['id']
    this.savedMessage['tags'] = `${this.seller}, ${this.reportForm.get('from_shopper').value}, ${this.reportForm.get('title').value}, ${this.reportForm.get('message').value}, ${this.reportForm.get('email').value}, ${this.savedMessage['selleremail']}, ${String(this.savedMessage['report'])}, ${String(this.savedMessage['post_id'])}`
    this.apiService.postMessage(this.savedMessage).subscribe(data => {
      this.submitted = 'submitted'
    })
  }

  swipeRight() {
    this.loading = true;
    if (this.imgIndex === this.merchandise['gallery'].length - 1) {
      this.imgIndex = 0
      this.loading = false;

    }

    else {
      this.imgIndex++
      this.loading = false;

    }

  }

  swipeLeft() {
    if (this.imgIndex === 0) {
      this.imgIndex = this.merchandise['gallery'].length - 1
    }

    else {
      this.imgIndex--
    }
  }
}
